/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Address/Addresses/Content/Address"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let addressPostalAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'address',
path: 'postal_address.address_line1',
})
let constantData = ', '
let addressPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'address',
path: 'postal_address.city',
})
let constantData1 = ', '
let addressPostalAddressStateValueData = fromData.useDataValue({ viewPath,
context: 'address',
path: 'postal_address.state',
})
let constantData2 = ', '
let addressPostalAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'address',
path: 'postal_address.zip',
})
let aggregateData = fromAggregate.join(addressPostalAddressAddressLine1ValueData, constantData, addressPostalAddressCityValueData, constantData1, addressPostalAddressStateValueData, constantData2, addressPostalAddressZipValueData)
  return (<React.Fragment
>
<div
  data-testid="Address.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-BkxIm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Address.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="address.postal_address.address_line1"
 data="', '"
 data="address.postal_address.city"
 data="', '"
 data="address.postal_address.state"
 data="', '"
 data="address.postal_address.zip"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}